/* Tysk katalog for locale-completion-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  "common.rowUnavailable": "Die Daten konnten nicht geladen werden. Versuchen Sie es erneut.",
  "common.rowContextChanged": "Das ausgew?hlte Unternehmen oder Dokument hat sich ge?ndert. ?ffnen Sie es erneut.",
  "common.bankStatementIncomplete": "Der Kontoauszug ist noch nicht vollst?ndig geladen. Versuchen Sie es erneut.",
  "common.journalProofUnavailable": "Die Buchhaltungsdaten konnten nicht ?berpr?ft werden.",

  'pay.employeesAwaitingPayment': '{{count}} Mitarbeitende warten auf Auszahlung',
  'pay.readyForPayment': 'Bereit zur Auszahlung',
  'pay.readyForPaymentHelp': 'Freigegebene und gebuchte Lohnläufe, deren Lohn noch nicht als ausgezahlt erfasst ist.',
  'pay.noRunsAwaitingPayment': 'Keine Lohnläufe warten auf Auszahlung',
  'pay.noRunsAwaitingPaymentHint': 'Freigegebene Lohnläufe werden hier angezeigt, bis die Auszahlung erfasst ist.',
  'pay.draftPayrollRuns': 'Entwürfe',
  'pay.noDraftPayrollRuns': 'Keine Lohnentwürfe.',
  'buy.ownerOutlay': 'Auslage des Inhabers',
  'home.followup.assetPostingTitle': 'Abschreibungen',
  'home.followup.assetPostingAction': 'Abweichung ansehen',
  'home.followup.assetPostingIssue': 'Die automatische Abschreibung muss nachverfolgt werden. Prüfe den Plan des Vermögenswerts oder kontaktiere den Support. Plumme versucht es erneut, sobald die Abweichung behoben ist.',
  'ui.cancel': 'Abbrechen',
  'ui.close': 'Schließen',
  'ui.back': 'Zurück',
  'ui.continue': 'Weiter',
  'ui.open': 'Öffnen',
  'app.close': 'Schließen',
  'common.loadMore': 'Mehr laden', 'common.loading': 'Wird geladen...',
  'shell.collapse': 'Menü einklappen',
  'chat.cardFromFirm': 'Dein Buchhalter schrieb',
  'chat.cardFromYou': 'Du schriebst',
  'chat.cardNone': 'Noch keine Nachrichten',
  'chat.firm': 'Dein Buchhalter',
  'chat.helpTitle': 'Dein Buchhalter',
  'chat.help': 'Schreib direkt an deinen Buchhalter. Nur du als Inhaber oder Administrator siehst diese Unterhaltung.',
  'chat.cardOpenUnread': 'Nachricht lesen',
  'chat.cardOpen': 'Nachricht senden',
  'chat.modalTitle': 'Du hast eine ungelesene Nachricht',
  'chat.modalOpen': 'Chat öffnen',
  'chat.modalBody': 'hat dir eine Nachricht gesendet, die du noch nicht gelesen hast.',
  'chat.client': 'Der Mandant',
  'chat.subFirm': 'Dialog mit dem Mandanten',
  'chat.subClient': 'Dialog mit deinem Buchhalter',
  'chat.emptyFirm': 'Noch keine Nachrichten. Schreib dem Mandanten hier — er sieht sie in Plumme.',
  'chat.emptyClient': 'Noch keine Nachrichten. Frag deinen Buchhalter, was du wissen möchtest.',
  'chat.placeholder': 'Nachricht schreiben …',
  'chat.send': 'Senden',
  'rf.client.takeoverSaved': 'Das Übernahmedatum wurde gespeichert',
  'rf.client.takeover': 'Übernahmedatum',
  'rf.client.takeoverHelp': 'Zeiträume und Fristen vor diesem Datum gelten nicht als Arbeit des Büros. Die eigenen Pflichten des Mandanten ändern sich nicht.',
  'rf.client.takeoverSave': 'Datum speichern',
  'clo.cash.invalidAmount': 'Gib den gezählten Kassenbestand ein.',
  'clo.cash.documentationRequired': 'Beschreibe die Dokumentation der Zählung, bevor du freigibst.',
  'clo.cash.saved': 'Die Kassenzählung wurde gespeichert.',
  'clo.cash.saveError': 'Die Kassenzählung konnte nicht gespeichert werden.',
  'clo.cash.title': 'Münzen und Scheine',
  'clo.cash.readySubtitle': 'Der Kassenbestand ist gezählt und stimmt mit Konto 1900 überein.',
  'clo.cash.naSubtitle': 'Auf Konto 1900 ist kein Kassenbestand erfasst.',
  'clo.cash.todoSubtitle': 'Zähle den Kassenbestand zum 31.12 und vergleiche ihn mit Konto 1900.',
  'clo.cash.noStatus': 'Der Kassenstatus ist noch nicht berechnet.',
  'clo.cash.booked': 'Gebucht auf 1900',
  'clo.cash.counted': 'Gezählt zum 31.12',
  'clo.cash.difference': 'Differenz',
  'clo.cash.countedField': 'Gezählter Kassenbestand',
  'clo.cash.account': 'Kassenkonto',
  'clo.cash.documentation': 'Dokumentation der Zählung',
  'clo.cash.documentationPlaceholder': 'Zum Beispiel: Kasse am 31.12 vom Geschäftsführer gezählt. Zählprotokoll liegt im Belegordner.',
  'clo.cash.noDifferenceHelp': 'Stimmt der gezählte Bestand mit Konto 1900 überein, wird die Zählung ohne zusätzliche Buchung als Dokumentation gespeichert.',
  'clo.cash.surplusHelp': 'Die Differenz erhöht Konto 1900 und wird gegen sonstige Erträge gebucht.',
  'clo.cash.shortageHelp': 'Die Differenz verringert Konto 1900 und wird gegen sonstigen Aufwand gebucht.',
  'clo.cash.approve': 'Zählung freigeben',
  'clo.chart.suggestionsReady': 'Die Vorschläge sind bereit zur Freigabe.',
  'clo.chart.noSuggestions': 'Keine sicheren Vorschläge gefunden.',
  'clo.chart.pickBeforeApprove': 'Wähle ein Standardkonto, bevor du freigibst.',
  'clo.chart.saved': '{{count}} Kontozuordnungen gespeichert',
  'clo.chart.saveError': 'Die Kontozuordnungen konnten nicht gespeichert werden.',
  'clo.chart.title': 'Kontenplan',
  'clo.chart.missingSubtitle': '{{count}} eigenen Konten fehlt die Zuordnung zu einem Standardkonto.',
  'clo.chart.readySubtitle': 'Der Kontenplan ist bereit für den Jahresabschluss.',
  'clo.chart.allMapped': 'Alle benutzerdefinierten Konten sind einem Standardkonto zugeordnet.',
  'clo.chart.instructions': 'Wähle, welchem Standardkonto jedes eigene Konto entspricht.',
  'clo.chart.aiSuggest': 'Vorschläge mit KI finden',
  'clo.chart.accountFallback': 'Konto {{code}}',
  'clo.chart.missingMapping': 'Standardzuordnung fehlt',
  'clo.chart.equivalent': 'Entsprechendes Standardkonto',
  'clo.chart.reset': 'Vorschläge zurücksetzen',
  'clo.chart.approve': '{{count}} Vorschläge freigeben',
  'clo.share.title': 'Aktienkapital',
  'clo.share.readySubtitle': 'Das Aktienkapital ist auf Konto 2000 gebucht.',
  'clo.share.missingSubtitle': 'Prüfe oder buche das Aktienkapital, bevor der Jahresabschluss abgeschlossen wird.',
  'clo.share.noStatus': 'Der Status des Aktienkapitals ist noch nicht berechnet.',
  'clo.share.booked': 'Gebucht auf 2000',
  'clo.share.minimum': 'Mindestbetrag für eine norwegische AS',
  'clo.share.lossNote': 'Verluste oder verlorenes Eigenkapital werden normalerweise nicht von Konto 2000 ausgebucht. Sie werden bei Eigenkapital, Ergebnisverwendung und Unternehmensfortführung bewertet. Dieser Punkt prüft nur, ob das eingetragene Aktienkapital im Haben auf 2000 gebucht ist.',
  'clo.share.freePosting': 'Aktienkapital buchen',
  'sharedText.app.employeePortalVerifyTitle': 'Bestätige deine E-Mail-Adresse',
  'sharedText.auth.remember': 'Angemeldet bleiben',
  'sharedText.auth.noAccount': 'Noch kein Konto?',
  'sharedText.auth.forgotCopy': 'Gib die E-Mail-Adresse ein, mit der du dich anmeldest, dann senden wir dir einen Link zum Festlegen eines neuen Passworts.',
  'sharedText.acc.sentLinkTo': 'Wir haben einen Link gesendet an',
  'sharedText.rep.export.year': 'Jahr',
  'sharedText.bank.previewVoucher': 'Belegvorschau',
  'sharedText.km.returnTrip': 'Hin und zurück',
  'sharedText.pay.paidOut': 'Ausgezahlt',
  'sharedText.inv.col.net': 'Netto',
  'sharedText.transaction.by': 'von',
  'sharedText.buy.pickCategory': 'Konto/Kategorie',
  'sharedText.vat.vat': 'MwSt.',
  'sharedText.sup.seeVoucher': 'Beleg ansehen',
  'sharedText.bwf.correctEntry': 'Buchung korrigieren',
  'sharedText.ap.approve': 'Freigeben',
  'sharedText.sale.pay.partialStatusRemaining': 'offen',
  'sharedText.helpTopics.ocrCorrection.title': 'Erkennung korrigieren',
  'sharedText.pay.note': 'Notiz',
  'sharedText.bank.openingBalance': 'Anfangssaldo',
  'sharedText.asset.closing': 'Endsaldo',
  'sharedText.sale.att.dropHere': 'Beleg hier ablegen',
  'sharedText.voucher.pickAccount': 'Konto wählen',
  'sharedText.adv.scn.plan.interest': 'Zinsen',
  'sharedText.sale.pay.fee': 'Gebühr',
  'sharedText.ui.cancel': 'Abbrechen',
  'sharedText.bwf.selectLine': 'Bankzeile wählen',
  'sharedText.bg.bankLines': 'Bankzeilen',
  'sharedText.home.ana.ring': 'Verteilung',
  'sharedText.pj.row.new': 'Neue Zeile',
  'sharedText.bank.bankLine': 'Bankzeile',
  'sharedText.helpTopics.openItem.title': 'Offener Posten',
  'sharedText.clo.amount': 'Betrag',
  'sharedText.adv.status.more': 'Weitere Optionen',
  'sharedText.inboxStatus.dropReceipts': 'Belege hier ablegen',
  'sharedText.bank.uploading': 'Wird hochgeladen …',
  'sharedText.set.showAll': 'Alle anzeigen',
  'sharedText.bank.voucherReceivedOn': 'Beleg empfangen am',
  'sharedText.set.acc.lines': 'Zeilen',
  'sharedText.nav.budget': 'Budget',
  'sharedText.bud.actual': 'Ist',
  'sharedText.ui.close': 'Schließen',
  'sharedText.pay.signOut': 'Abmelden',
  'sharedText.rf.group.firm': 'Buchhalter',
  'sharedText.rf.create.title': 'Buchhaltungsbüro anlegen',
  'sharedText.ui.open': 'Öffnen',
  'sharedText.buy.next': 'Weiter',
  'sharedText.adv.docs.hide': 'Ausblenden',
  'sharedText.fe.decline': 'Ablehnen',
  'sharedText.common.yes': 'Ja',
  'sharedText.ap.review.checked': 'Geprüft',
  'sharedText.clo.pick': 'Wählen',
  'sharedText.nav.taxReturn': 'Skattemelding',
  'sharedText.clo.financialYear': 'Das Geschäftsjahr',
  'sharedText.helpTopics.residualValue.title': 'Restwert',
  'sharedText.clo.inventoryReview.undecided': 'Bewertung wählen',
  'sharedText.helpTopics.readyForUse.title': 'Betriebsbereit',
  'sharedText.asset.work.residualValue': 'Erwarteter Restwert',
  'sharedText.inv.credit.line': 'Zeile',
  'sharedText.buy.paid': 'Bezahlt',
  'sharedText.km.from': 'Von',
  'sharedText.km.to': 'Nach',
  'sharedText.set.accountNo': 'Kontonr.',
  'sharedText.sale.credit.previewReason': 'Grund:',
  'sharedText.clo.description': 'Beschreibung',
  'sharedText.prd.price': 'Preis',
  'sharedText.clo.sum': 'Summe',
  'sharedText.inv.kpi.sub.exVat': 'Ohne MwSt.',
  'sharedText.set.page': 'Seite',
  'sharedText.sale.cust.org': 'Org.-Nr.',
  'sharedText.trv.vehicle': 'Fahrzeug',
  'sharedText.ap.monthControl.finding.deviation': 'Mögliche Abweichung',
  'sharedText.vat.cancel': 'Stornieren',
  'sharedText.bank.review': 'Prüfen',
  'sharedText.inbox.supplierInvoice': 'Lieferantenrechnung',
  'sharedText.bank.roundingHelp': 'Nutze dies nur für eine echte kleine Rundungsdifferenz. Der Betrag wird ohne MwSt. gebucht gegen',
  'sharedText.trv.reason': 'Begründung',
  'sharedText.set.acc.vatRegisteredPick': 'Antwort wählen',
  'sharedText.set.acc.vatRegisteredUnknown': 'Weiß nicht',
  'sharedText.set.acc.vatRegisteredFrom': 'MwSt.-registriert seit',
  'sharedText.vat.due': 'Frist',
  'sharedText.pay.advance': 'Vorschuss',
  'sharedText.pay.aga': 'AGA',
  'sharedText.inv.col.number': 'Nr.',
  'sharedText.onb.createPersonal': 'Erstelle deine Privatfinanzen',
  'sharedText.onb.createPersonalHelp': 'Damit wird ein eigener Privatfinanzen-Benutzer angelegt, den du unter Meine Seite und in der Benutzerauswahl findest.',
  'sharedText.onb.noBankData': 'Die Bankanbindung ist noch nicht aktiv. Du kannst Kontoauszüge jederzeit manuell hochladen.',
  'sharedText.po.youHaveStated': 'Du hast angegeben, dass',
  'sharedText.po.wealthStrongestOn': 'Dein Vermögen schneidet am besten ab bei',
  'sharedText.po.withYourAssumptions': 'Mit deinen eingegebenen Annahmen verändert sich dein Vermögen um etwa',
  'sharedText.po.splitIsEven': 'Die Aufteilung ist gleichmäßig. Ihr teilt',
  'sharedText.po.householdHasRegistered': 'Der Haushalt hat erfasst',
  'sharedText.po.budgetTotal': 'Budget gesamt:',
  'sharedText.set.bank.typeTax': 'Steuerabzug',
  'sharedText.clo.no': 'Nein',
  'sharedText.po.showingScenario': 'Angezeigtes Szenario:',
  'sharedText.po.desiredNetWealth': 'Gewünschtes Nettovermögen',
  'sharedText.po.lastsUntilYouAre': 'reicht, bis du',
  'sharedText.sd.transition.years': 'Jahre',
  'sharedText.po.lasts': 'reicht',
  'sharedText.po.prioritise': 'Priorisieren',
  'sharedText.adv.scn.loan.monthsUnit': 'Mon.',
  'sharedText.po.doYouWantToDelete': 'Möchtest du löschen:',
  'sharedText.po.householdSpends': 'Der Haushalt gibt aus',
  'sharedText.po.iRecommend': 'Ich empfehle',
  'sharedText.po.debtFree': 'Schuldenfrei',
  'sharedText.po.interestPostedAs': 'Zinsen und Tilgungen für dieses Darlehen werden gebucht als',
  'sharedText.helpTopics.buffer.title': 'Liquiditätspuffer',
  'sharedText.clo.save': 'Speichern',
  'sharedText.adv.profile.buffer': 'Gewünschter Puffer',
  'sharedText.home.legend.income': 'Einnahmen',
  'sharedText.set.bank.typeSavings': 'Sparen',
  'sharedText.pay.category': 'Kategorie',
  'sharedText.set.account': 'Konto',
  'sharedText.po.allAccounts': 'Alle Konten',
  'sharedText.adv.status.snooze7': 'In einer Woche erinnern',
  'sharedText.po.yourHealthScoreIs': 'Dein Gesundheitsscore ist',
  'sharedText.po.outOf100': 'von 100',
  'sharedText.po.taxAssistant': 'Steuererklärungs-Assistent',
  'sharedText.cust.prev': 'Zurück',
  'sharedText.bank.finishReview': 'Prüfung abschließen',
  'sharedText.po.checkBasis': 'Prüfgrundlage',
  'sharedText.clo.name': 'Name',
  'sharedText.set.text': 'Text',
  'sharedText.sale.textLine.boldShort': 'F',
  'sharedText.sale.textLine.italicShort': 'K',
  'sharedText.sale.lines.useDivider': 'Trennlinie verwenden',
  'sharedText.sale.textLine.dividerHint': 'Linie unter dem Text im Dokument anzeigen.',
  'sharedText.nav.products': 'Produkte',
  'sharedText.sale.textLine.titleNewText': 'Neue Textzeile',
  'sharedText.prd.deleted': 'Gelöscht',
  'sharedText.pay.edit': 'Bearbeiten',
  'sharedText.clo.delete': 'Löschen',
  'sharedText.set.loans.startDate': 'Startdatum',
  'sharedText.helpTopics.unitCost.title': 'Einstandspreis pro Einheit',
  'sharedText.pay.optional': 'Optional',
  'sharedText.registry.group': 'Produktgruppe',
  'sharedText.clo.add': 'Hinzufügen',
  'sharedText.ha.products.account': 'Erlöskonto',
  'sharedText.clo.accountNumber': 'Kontonummer',
  'sharedText.clo.accountName': 'Kontoname',
  'sharedText.buy.supplierNew': 'Neuer Lieferant',
  'sharedText.auth.createAccount': 'Konto erstellen',
  'sharedText.set.acc.equivalent': 'Entspricht Konto',
  'sharedText.bwf.entry': 'Buchung',
  'sharedText.sale.att.upload': 'Anhang hochladen',
  'sharedText.vat.settlement': 'Abrechnung',
  'sharedText.ap.agent.invoice.selectRow': 'Rechnung auswählen',
  'sharedText.ap.workspace.treatmentAsset': 'Als Anlagegut erfassen',
  'sharedText.bank.receiptLinked': 'Mit Bankzeile verknüpft',
  'sharedText.sd.documents.count': 'Dokumente',
  'sharedText.set.debit': 'Soll',
  'sharedText.set.bank.accounts': 'Bankkonten',
  'sharedText.sd.deleteBusinessHelp': '„Unternehmen löschen“ entfernt das ausgewählte Unternehmen nach 30 Tagen über das Backend. Das ist eine schwerwiegende Aktion.',
  'sharedText.vat.rate': 'Satz',
  'sharedText.inv.bulk.noEmail': 'keine E-Mail',
  'sharedText.trv.privateRefundOf': 'Private Erstattung von',
  'sharedText.asset.group': 'Gruppe',
  'sharedText.asset.opening': 'Anfangsbestand',
  'sharedText.asset.movements': 'Bewegungen',
  'sharedText.set.credit': 'Haben',
  'sharedText.voucher.backToVat': 'Zurück zur MVA-melding',
  'sharedText.vat.vatCode': 'MwSt.-Code',
  'sharedText.bank.markVoucherLostTitle': 'Beleg als verloren markieren',
  'sharedText.bank.voucherLostReason': 'Erklärung',
  'pay.salaryLineDeleted': 'Die Lohnzeile wurde gelöscht.',
  'pay.salaryLineNotFound': 'Die Lohnzeile existiert nicht mehr.',
  'pay.deleteSalaryLine': 'Lohnzeile löschen',
  'pay.deleteSalaryLineConfirm': 'Möchtest du „{{name}}“ aus diesem Lohnentwurf löschen?',
  'pay.accountingVouchers': 'Buchungsbelege',
  'pay.payrollVoucher': 'Lohnbeleg',
  'pay.paymentVoucher': 'Zahlungsbeleg',
  'pay.paymentVoucherInDifferentYear': 'Die Zahlung wurde {{year}} gebucht und erscheint daher in der Summen- und Saldenliste dieses Jahres.',
  'pay.settleSalaryLiability': 'Ausgleich geschuldeter Löhne',
  'pay.settleEmployeeExpense': 'Ausgleich von Auslagen',
  'pay.paymentFromBank': 'Auszahlung vom Bankkonto',
});
